import React from 'react';

import { Button, Text } from '../../../../components';
import {
  nextTierKey,
  sortTierKeys,
} from '../../utils/voicemailDetectionPatterns';
import { TierBlock } from './TierBlock';
import type { LanguageBlockProps } from './types';
import { Add } from '@mui/icons-material';

export const LanguageBlock: React.FC<LanguageBlockProps> = ({
  langCode,
  langLabel,
  tiers,
  disabled,
  onChange,
}) => {
  const sortedTierKeys = sortTierKeys(Object.keys(tiers));

  const updateTier = (tierKey: string, strings: string[]) => {
    if (strings.length === 0) {
      const { [tierKey]: _removed, ...rest } = tiers;
      onChange(rest);
    } else {
      onChange({ ...tiers, [tierKey]: strings });
    }
  };

  const addTier = () => {
    const key = nextTierKey(tiers);
    onChange({ ...tiers, [key]: [''] });
  };

  return (
    <div className="border border-gray-200 rounded-xl p-4 flex flex-col gap-4 bg-gray-50">
      <div className="flex items-center justify-between">
        <Text className="text-medium font-semibold text-mainText">
          {langLabel}{' '}
          <Text
            as="span"
            variant="secondary"
            className="font-normal text-small"
          >
            ({langCode})
          </Text>
        </Text>
        <Button
          size="small"
          type="outline"
          icon={<Add fontSize="small" />}
          disabled={disabled}
          label="Add tier"
          onClick={addTier}
        />
      </div>

      {sortedTierKeys.length === 0 && (
        <Text variant="secondary" className="text-small italic">
          No tiers yet. Add a tier to define patterns.
        </Text>
      )}

      {sortedTierKeys.map(tierKey => (
        <TierBlock
          key={tierKey}
          tierKey={tierKey}
          strings={tiers[tierKey] ?? []}
          disabled={disabled}
          onChange={strings => updateTier(tierKey, strings)}
        />
      ))}
    </div>
  );
};
